export default __webpack_public_path__ + "static/media/logo_full_white.5755cd8a.png";